<bfa-modal width="620px" [enableBackdrop]="true" [enableClose]="false" [isVisible]="true" (isVisibleChange)="close()">
	<div *ngIf="isShown" class="export-model-modal reveal">
		<form (ngSubmit)="sendToPlatform()" #exportForm="ngForm">
			<div class="border-bottom" *ngIf="mode === 'editOriginal'">
				<h1 class="modal-title text-20" dcrHTMLKey="EDIT_ORIGINAL_TITLE_EXTERNAL">Edit Original Model</h1>

				<ng-container *ngIf="!shouldFlattenPortfolio; else flattenPortfolioDisclaimer"></ng-container>

				<p class="modal-title-message text-16">
					<span dcrHTMLKey="EDIT_ORIGINAL_DRAFT_EDIT_EXTERNAL"> The Portfolio will be submitted as an edit to </span>
					<span class="text-16-bold">{{ baseModelName }}</span>
				</p>
				<p class="modal-title-message text-16" dcrHTMLKey="EDIT_ORIGINAL_TITLE_MESSAGE_EXTERNAL">
					This portfolio will be submitted as a draft in your system for you to action. BlackRock is not responsible for its execution, and does not control the content
					or services provided on any third party site.
				</p>
			</div>

			<div class="border-bottom" *ngIf="mode === 'createNew'">
				<h1 class="modal-title text-20" dcrHTMLKey="CREATE_NEW_TITLE_EXTERNAL">Create New Model</h1>

				<ng-container *ngIf="!shouldFlattenPortfolio; else flattenPortfolioDisclaimer"></ng-container>

				<p class="modal-title-message text-16" dcrHTMLKey="CREATE_NEW_TITLE_MESSAGE_EXTERNAL">
					This portfolio will be submitted as a new model in your system for you to action. BlackRock is not responsible for its execution, and does not control the
					content or services provided on any third party site.
				</p>

				<div class="text-align-center">
					<input
						name="portfolioNameInput"
						class="portfolio-name-input padding-top-15 text-bold text-align-center"
						[style.width.ch]="portfolioNameUpdate.length"
						[ngModel]="portfolioNameUpdate"
						(ngModelChange)="onPortfolioNameChange($event)" />
					<div *ngIf="isPortfolioNameInvalid && !isPortfolioUpdateLoading" class="portfolio-name-invalid" dcrHTMLKey="EXPORT_MODEL_PORTFOLIO_NAME_INVALID">
						Please rename the portfolio before sending to platform.
					</div>
				</div>

				<section class="row portfolio-details">
					<section class="ac-dropdown col-12">
						<select required (change)="onProgramHandleChange($event)">
							<option value="" [hidden]="true" [disabled]="true" [selected]="true" dcrHTMLKey="PROGRAM_TYPE_LABEL">Program Type</option>
							<option *ngFor="let programHandleListOption of programHandleListOptions$ | async" value="{{ programHandleListOption.handle }}">
								<section>{{ programHandleListOption.name }}</section>
							</option>
						</select>
					</section>
				</section>
				<section class="row portfolio-details last">
					<section class="ac-dropdown col-12">
						<select required (change)="onRiskHandleChange($event)">
							<option value="" [hidden]="true" [disabled]="true" [selected]="true" dcrHTMLKey="TARGET_RISK_LABEL">Target Risk Rating</option>
							<option *ngFor="let riskScaleListOption of riskScaleListOptions$ | async" value="{{ riskScaleListOption.handle }}">
								<section>{{ riskScaleListOption.name }}</section>
							</option>
						</select>
					</section>
				</section>
			</div>

			<div class="modal-disclaimer text-condensed-14">
				<p class="text-condensed-bold" dcrHTMLKey="EXPORT_DISCLAIMER_P1">
					By clicking the “Send to Platform” button below, you agree that you have read and acknowledged the following statements:
				</p>
				<br />
				<p dcrHTMLKey="EXPORT_DISCLAIMER_P2">
					I, the financial professional, do not construe or rely upon any information contained in, or generated by, the BlackRock Site as discretionary and/or
					personalized investment advice, research or a recommendation by BlackRock regarding the use or suitability of any particular asset allocation, fund or overall
					investment strategy.
				</p>
				<br />
				<p dcrHTMLKey="EXPORT_DISCLAIMER_P3">
					In connection with any recommendation or decision I may make to invest my client’s account in a particular investment, I am fully responsible for the
					independent determination that the investment is appropriate and suitable based on my client’s investment profile and circumstances.
				</p>
			</div>

			<section class="row">
				<section class="modal-button text-align-left action col-12">
					<button dz-button (click)="close()" [track-event]="getTrackMessage('cancel')">Cancel</button>
				</section>
				<section class="modal-button text-align-right action col-12">
					<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
					<button
						type="submit"
						dz-button
						[disabled]="isSendToPlatformDisabled()"
						[track-event]="getTrackMessage('send-to-platform')"
						dcrHTMLKey="SEND_TO_PLATFORM_BUTTON_LABEL">
						Send to platform
					</button>
				</section>
			</section>
		</form>
	</div>

	<div *ngIf="isSaved || (validationMessages && validationMessages.length)" class="export-model-modal reveal modal-background">
		<div class="modal-icon"><img ada-decorative [remote-src]="imagePath" /></div>

		<h1 class="modal-title confirmation-title text-20" *ngIf="validationMessages.length" dcrHTMLKey="EXPORT_WARNING_TITLE">We are unable to export this portfolio.</h1>
		<section *ngFor="let message of validationMessages">
			<p class="modal-title-message text-16">
				{{ 'This functionality is temporarily unavailable. Please try again later.' | dcr: 'PARTNER_EXPORT_' + message.code }}
			</p>
			<p class="modal-title-message padding-top-15" *ngIf="showInvalidSecuritiesInModal(message)">
				{{ message.securities.join(', ') }}
			</p>
		</section>

		<section *ngIf="isSaved">
			<section class="border-bottom">
				<h1 class="modal-title confirmation-title text-20" dcrHTMLKey="EXPORT_SUCCESSFUL_TITLE">Export Successful!</h1>
				<p *ngIf="mode === 'createNew'" class="modal-title-message text-16" dcrHTMLKey="EXPORT_SUCCESSFUL_CREATE_MESSAGE">
					Please visit your platform to action this new model. BlackRock is not responsible for its execution, and does not control the content or services provided on
					any third party site.
				</p>
				<p *ngIf="mode === 'editOriginal'" class="modal-title-message text-16" dcrHTMLKey="EXPORT_SUCCESSFUL_EDIT_MESSAGE">
					Please visit your platform to action these changes to the original model. BlackRock is not responsible for its execution, and does not control the content or
					services provided on any third party site.
				</p>
			</section>
			<section class="modal-disclaimer">
				<p class="text-condensed-14-bold" dcrHTMLKey="EXPORT_SUCCESSFUL_DISCLAIMER">
					By clicking the “Go to Platform” button below, you acknowledge that you will be leaving BlackRock.com
				</p>
			</section>
		</section>

		<section class="row">
			<section
				*ngIf="!isSaved || isPortfolioUpdateFailing"
				[ngClass]="{ 'modal-button text-align-left action col-12': !isModelViewOnly, 'modal-button text-align-center action col-24': isModelViewOnly }">
				<button dz-button (click)="close()">Cancel</button>
			</section>

			<!-- if securities are not eligible or invalid, show Edit Portfolio -->
			<section
				*ngIf="!isSaved && !isPortfolioUpdateFailing && validationMessages && !hasAlert(validationMessages) && !isModelViewOnly"
				class="modal-button text-align-right action col-12">
				<button dz-button (click)="editPortfolio()" dcrHTMLKey="EXPORT_MODEL_EDIT_PORTFOLIO_LABEL">Edit Portfolio</button>
			</section>

			<!-- if success, go to platform -->
			<section *ngIf="isSaved" class="modal-button text-align-left action col-12">
				<button dz-button (click)="close()" dcrHTMLKey="GO_BACK_BUTTON_LABEL">Go Back</button>
			</section>
			<section *ngIf="isSaved" class="modal-button text-align-right action col-12">
				<button dz-button (click)="goToPlatform()" custom-tracking track-event="portfolio-export-modal:cta:go-to-platform" dcrHTMLKey="GO_TO_PLATFORM_BUTTON_LABEL">
					Go to platform
				</button>
			</section>

			<!-- else if other generic error including WTP calls failing, retry -->
			<section *ngIf="isPortfolioUpdateFailing || (validationMessages && hasAlert(validationMessages))" class="modal-button text-align-right action col-12">
				<button dz-button (click)="retry()">Retry</button>
			</section>
		</section>
	</div>
	<ng-template #flattenPortfolioDisclaimer>
		<div class="border-bottom padding-top-20"></div>
		<div class="row padding-10">
			<p class="text-14">
				<icon class="color-orange" type="exclamation-triangle"></icon>
				<span class="icon-caption text-bold padding-left-10" dcrHTMLKey="FLATTEN_PORTFOLIO_DISCLAIMER">FLATTEN_PORTFOLIO_DISCLAIMER</span>
			</p>
		</div>
		<div class="border-bottom padding-top-20 margin-bottom-20"></div>
	</ng-template>

	<div class="d-flex justify-content-center align-items-center spinner">
		<dz-progress-spinner *ngIf="isSaving"></dz-progress-spinner>
	</div>
</bfa-modal>
